import { differenceInSeconds, format } from 'date-fns'

export const formatStrategyTime = (timestamp: string): string => {
    const now = new Date()
    const date = new Date(timestamp)

    const secondsDiff = differenceInSeconds(now, date)

    if (secondsDiff < 60) {
        return 'Just now'
    }

    return format(date, 'HH:mm')
}
